import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from '@/contexts/LanguageContext';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import Home from '@/pages/Home';
import Surgeries from '@/pages/Surgeries';
import SurgeryDetail from '@/pages/SurgeryDetail';
import QuoteRequest from '@/pages/QuoteRequest';
import Contact from '@/pages/Contact';
import { Toaster } from '@/components/ui/sonner';

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/surgeries" element={<Surgeries />} />
            <Route path="/surgeries/:id" element={<SurgeryDetail />} />
            <Route path="/quote" element={<QuoteRequest />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer />
          <Toaster position="top-right" />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;